import { FlexBox, FormField, FormGrid, Text } from '@dixa/lib-shared-habla';

import { FieldToggleBoxHead, ToggleBox } from 'fable/toggleBox';

import type { SettingsProps } from '../../types/settings';
import {
  WaitingTimeSettings,
  WaitingTimeSettingType,
} from '../waitingTimeSettings/waitingTimeSettings';

export function LastAgentSettings({ formValues }: SettingsProps): JSX.Element {
  return (
    <FormGrid>
      <FormField>
        <FlexBox flexDirection="column" gap="100" margin="0 0 200">
          <Text.Heading variant="heading-3">
            Last agent{' '}
            <Text.Paragraph subdued as="span">
              (personal offers)
            </Text.Paragraph>
          </Text.Heading>

          <Text.Paragraph subdued>
            Offer ongoing conversations with new messages to the agent that
            wrote the last response, and follow-ups back to the agent that
            originally marked it as follow-up.
          </Text.Paragraph>
        </FlexBox>
      </FormField>

      <FormField>
        <ToggleBox
          headComponent={FieldToggleBoxHead}
          isOpen={formValues.is_do_not_offer_enabled}
          textProps={{ variant: '2' }}
          title="Activate last agent"
          input={{
            id: 'is_do_not_offer_enabled',
            value: 'is_do_not_offer_enabled',
            name: 'is_do_not_offer_enabled',
          }}
        />
      </FormField>

      {formValues.is_do_not_offer_enabled && (
        <>
          <FormField>
            <ToggleBox
              headComponent={FieldToggleBoxHead}
              isOpen={formValues.is_personal_offer_prioritized}
              textProps={{ variant: '2' }}
              title="Prioritize ongoing email conversations & follow-ups"
              input={{
                id: 'is_personal_offer_prioritized',
                value: 'is_personal_offer_prioritized',
                name: 'is_personal_offer_prioritized',
              }}
              helpIcon={{
                dark: true,
                text: 'Offer ongoing email conversations and follow-ups to agents before any new conversations that have been added to the queue in the meantime.',
              }}
            />
          </FormField>

          <FormField>
            <WaitingTimeSettings
              formValues={formValues}
              type={WaitingTimeSettingType.LastAgent}
            />
          </FormField>
        </>
      )}
    </FormGrid>
  );
}
